import React, { useEffect, useState, useRef } from 'react';
import printJS from 'print-js';
import './printStickerPage.css';
import JsBarcode from 'jsbarcode';

function PrintStickerPage() {
    const [stickers, setStickers] = useState([]);
    const [layout, setLayout] = useState('a4'); // 'a4' or 'roll'
    const [loading, setLoading] = useState(true);
    const [barcodesReady, setBarcodesReady] = useState(false);
    const componentRef = useRef();

    const handlePrint = () => {
        if (!barcodesReady) {
            console.warn('Barcodes not ready yet');
            return;
        }
        
        console.log('Printing element:', document.getElementById('print-content'));
        
        printJS({
            printable: 'print-content',
            type: 'html',
            targetStyles: ['*'],
            scanStyles: false,
            style: `
                @page { 
                    size: 76mm auto;
                    margin: 0; 
                }
                html, body {
                    margin: 0;
                    padding: 0;
                    width: 76mm;
                    max-width: 76mm;
                }
                #print-content {
                    width: 76mm !important;
                    max-width: 76mm !important;
                    margin: 0;
                    padding: 0;
                }
                .sticker-print-item { 
                    width: 69.9mm !important;
                    height: 29.9mm !important;
                    margin: 0 auto 3mm auto;
                    padding: 0;
                    border: 1px solid #000;
                    page-break-inside: avoid;
                    display: block;
                    box-sizing: border-box;
                }
                .sticker-print-item:first-child { 
                    margin-top: 0; 
                }
                .sticker-content { 
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    width: 100%;
                    height: 100%;
                    padding: 1mm;
                    box-sizing: border-box;
                }
                .product-name { 
                    font-size: 11px;
                    color: #000;
                    text-align: center;
                    margin-bottom: 2px;
                    line-height: 1.2;
                }
                .barcode-container { 
                    display: flex;
                    flex: 1;
                    width: 100%;
                    align-items: center;
                    justify-content: center;
                }
                .barcode-container canvas { 
                    max-width: 90%;
                    height: auto;
                }
            `
        });
    };

    useEffect(() => {
        // Parse URL parameters from hash (HashRouter)
        const hashParts = window.location.hash.split('?');
        const queryString = hashParts.length > 1 ? hashParts[1] : '';
        const urlParams = new URLSearchParams(queryString);
        
        const stickersParam = urlParams.get('stickers');
        const layoutParam = urlParams.get('layout');
        
        console.log('PrintStickerPage URL params:', { stickersParam, layoutParam });
        
        if (stickersParam) {
            try {
                const parsed = JSON.parse(decodeURIComponent(stickersParam));
                setStickers(parsed);
                console.log('Parsed stickers:', parsed);
            } catch (err) {
                console.error('Error parsing stickers:', err);
            }
        }
        
        if (layoutParam) {
            setLayout(layoutParam);
        }
        
        setLoading(false);
        
        // Auto-print disabled - user can click Imprimir button when ready
        // setTimeout(() => {
        //     window.print();
        // }, 500);
    }, []);

    useEffect(() => {
        // Generate barcodes for all stickers
        console.log('Generating barcodes for stickers:', stickers);
        if (stickers.length === 0) {
            setBarcodesReady(false);
            return;
        }
        
        let allGenerated = true;
        stickers.forEach((sticker, index) => {
            const canvasId = `barcode-canvas-${sticker.ProductId}`;
            const canvas = document.getElementById(canvasId);
            console.log(`Canvas ${canvasId}:`, canvas);
            if (canvas && sticker.ProductCode) {
                try {
                    JsBarcode(canvas, sticker.ProductCode, {
                        format: 'CODE128',
                        width: 2,
                        height: 50,
                        displayValue: true,
                        fontSize: 14,
                        margin: 2
                    });
                    console.log(`✓ Barcode generated for ${sticker.ProductCode}`);
                } catch (error) {
                    console.error(`Error generating barcode for ${sticker.ProductCode}:`, error);
                    allGenerated = false;
                }
            } else {
                console.warn(`Missing canvas or ProductCode for sticker ${index}`);
                allGenerated = false;
            }
        });
        
        setBarcodesReady(allGenerated);
        console.log('Barcodes ready:', allGenerated);
    }, [stickers]);

    if (loading) {
        return <div className="loading">Cargando etiquetas...</div>;
    }

    if (stickers.length === 0) {
        return (
            <div className="error">
                <p>No se encontraron etiquetas para imprimir.</p>
                <button onClick={() => window.close()}>Cerrar</button>
            </div>
        );
    }

    return (
        <>
            {/* Print Controls - Hidden on print */}
            <div className="print-controls-top">
                <button 
                    onClick={handlePrint}
                    style={{ 
                        backgroundColor: '#28a745',
                        color: 'white'
                    }}
                >
                    🖨️ Imprimir
                </button>
                <button 
                    onClick={() => window.close()} 
                    style={{ 
                        backgroundColor: '#f5d540', 
                        color: 'black' 
                    }}
                >
                    Cerrar
                </button>
            </div>

            {/* Centered Preview Container - EXACTLY like printQuotePage */}
            <div style={{ display: 'flex', justifyContent: 'center', padding: '20px' }}>
                <div id="print-content" ref={componentRef} className={`sticker-print-container layout-${layout}`}>
                    {stickers.map((sticker, index) => (
                        <div key={index} className="sticker-print-item">
                            <div className="sticker-content">
                                <div className="product-name">
                                    {sticker.ProductDescription || 'Sin descripción'}
                                </div>
                                <div className="barcode-container">
                                    <canvas id={`barcode-canvas-${sticker.ProductId}`}></canvas>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </>
    );
}

export default PrintStickerPage;
